import React from 'react';
import './Modal.css'; // kreiraćemo stilove

const PrivacyPolicyModal = ({ onClose }) => {
  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <button className="close-btn" onClick={onClose}>×</button>
        <div className="privacy-policy-content">
  <h2>POLITIKA PRIVATNOSTI</h2>
  <p><strong>Magna d.o.o.</strong><br />
  Adresa: Karađorđeva broj 2, 78000 Banja Luka<br />
  Email: magnakonsalting@gmail.com<br />
  Telefon: 065 489 998<br />
  Web: <a href="https://magna.ba" target="_blank" rel="noopener noreferrer">https://magna.ba</a></p>

  <h3>1. UVOD</h3>
  <p>
    Magna d.o.o. (u daljem tekstu: „Mi“ ili „Privredno društvo“) posvećena je zaštiti ličnih podataka svih korisnika svojih usluga, posjetilaca web stranice i partnera, u skladu sa Zakonom o zaštiti ličnih podataka Bosne i Hercegovine i Opštom uredbom o zaštiti ličnih podataka (GDPR).
  </p>
  <p>
    Ova Politika privatnosti objašnjava kako i zašto prikupljamo, obrađujemo i štitimo Vaše lične podatke.
  </p>

  <h3>2. KO JE ODGOVORAN ZA OBRADU VAŠIH LIČNIH PODATAKA?</h3>
  <p>
    <strong>Kontrolor podataka:</strong><br />
    Magna d.o.o.<br />
    Karađorđeva broj 2, 78000 Banja Luka<br />
    Email: magnakonsalting@gmail.com<br />
    Telefon: 065 489 998
  </p>

  <h3>3. KOJE PODATKE PRIKUPLJAMO?</h3>
  <p>Prikupljamo isključivo one lične podatke koji su neophodni za određenu svrhu, a u skladu sa principom smanjenja obima podataka:</p>
  <ul>
    <li>Ime i prezime, datum rođenja, adresa prebivališta, ime roditelja, broj lične karte, JMBG</li>
    <li>Kontakt podaci: broj telefona i email adresa</li>
    <li>Informacije unesene putem kontakt forme na web stranici</li>
    <li>Podaci potrebni za ispunjavanje ugovornih obaveza</li>
  </ul>

  <h3>4. SVRHA OBRADE PODATAKA</h3>
  <table className="policy-table">
    <thead>
      <tr>
        <th>Redni broj</th>
        <th>Svrha obrade</th>
        <th>Pravni osnov obrade</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td>1</td>
        <td>Odgovaranje na upite i pružanje usluga, realizacija uplata putem računa</td>
        <td>Izvršenje ugovora u kojem je nosilac podataka ugovorna strana ili preduzimanje radnji na zahtjev nosioca podataka prije zaključenja ugovora (član 8. stav 1. tačka b.) Zakona o zaštiti ličnih podataka.
</td>
      </tr>
      <tr>
        <td>2</td>
        <td>Zastupanje interesa klijenata pred institucijama</td>
        <td>Izvršenje ugovora u kojem je nosilac podataka ugovorna strana ili preduzimanje radnji na zahtjev nosioca podataka prije zaključenja ugovora (član 8. stav 1. tačka b.) Zakona o zaštiti ličnih podataka.</td>
      </tr>
      <tr>
        <td>3</td>
        <td>Priprema ponuda i ugovora</td>
        <td>Izvršenje ugovora u kojem je nosilac podataka ugovorna strana ili preduzimanje radnji na zahtjev nosioca podataka prije zaključenja ugovora (član 8. stav 1. tačka b.) Zakona o zaštiti ličnih podataka.</td>
      </tr>
      <tr>
        <td>4</td>
        <td>Vođenje evidencija propisanih internim propisima</td>
        <td>Poštovanje pravnih obaveza kontrolora podataka (član 8. stav 1. tačka c.) Zakona o zaštiti ličnih podatka. </td>
      </tr>
      <tr>
        <td>5</td>
        <td>Pokretanje zakonom propisanih postupaka u slučaju kršenja ugovora</td>
        <td>Legitimni interes kontrolora podataka ili treće strane, osim kada nad tim interesima pretežu interesi ili osnovna prava I slobode nosioca podataka (član 8. stav 1. tačka f.) Zakona o zaštit ličnih podataka.</td>
      </tr>
      <tr>
        <td>6</td>
        <td>Vođenje računovodstva</td>
        <td>Poštovanje pravnih obaveza kontrolora podataka (član 8. stav 1. tačka c.) Zakona o zaštoiti ličnih podakata.</td>
      </tr>
      <tr>
        <td>7</td>
        <td>Unapređenje kvaliteta usluga, komunikacije i marketinga</td>
        <td>Saglasnost (Član 8. stav 1. tačka a) Zakona o zaštiti ličnih podataka</td>
      </tr>
      <tr>
        <td>8</td>
        <td>Vođenje evidencija o zaposlenima, radni odnosi, obuke, obračun plata itd.</td>
        <td>Poštovanje pravnih obaveza kontrolora podataka (član 8. stav 1. tačka c.)</td>
      </tr>
      <tr>
        <td>9</td>
        <td>Video nadzor radi zaštite lica, imovine i prostora</td>
        <td>Legitimni interes kontrolora podataka ili 
treće strane, osim kada nad tim interesima 
pretežu interesi ili osnovna prava I 
slobode nosioca podataka (član 8. stav 1. tačka f.) Zakona o zaštiti ličnih podataka.</td>
      </tr>
    </tbody>
  </table>

  <h3>6. KOLIKO DUGO ČUVAMO VAŠE PODATKE?</h3>
  <ul>
    <li>Dok traje poslovna saradnja ili ugovorni odnos</li>
    <li>U skladu sa zakonskim obavezama čuvanja dokumentacije (npr. poreski propisi)</li>
    <li>Dok ne povučete saglasnost, ako je ona osnov za obradu</li>
  </ul>

  <h3>7. PRAVA LICA ČIJE PODATKE OBRAĐUJEMO</h3>
  <ul>
    <li>Zatražite pristup svojim podacima</li>
    <li>Zatražite ispravku, brisanje ili ograničenje obrade</li>
    <li>Uložite prigovor na obradu</li>
    <li>Tražite prenosivost podataka</li>
    <li>Povučete saglasnost u bilo kojem trenutku</li>
    <li>Podnesete pritužbu Agenciji za zaštitu ličnih podataka BiH</li>
  </ul>

  <h3>8. KOME SE PODACI MOGU OTKRITI?</h3>
  <ul>
    <li>Na zahtjev nadležne institucije, u skladu sa zakonom,</li>
    <li>Poslovne partnere kao što su knjigovodstvene agencije, IT podrška i slično, i to isključivo u svrhu obavljanja ugovorenih poslova, uz ugovornu obavezu povjerljivosti</li>
    <li>Drugim stranama uz Vašu izričitu saglasnost</li>
  </ul>

  <h3>9. BEZBJEDNOST PODATAKA</h3>
  <p>
    Preduzimamo odgovarajuće tehničke i organizacione mjere radi zaštite ličnih podataka od neovlaštenog pristupa, gubitka, zloupotrebe ili uništenja.
  </p>

  <h3>10. KOLAČIĆI (COOKIES)</h3>
  <p>
    Naša web stranica trenutno ne koristi, ali u budućnosti zadržavamo pravo da može koristiti kolačiće u svrhu osnovne funkcionalnosti, statistike i poboljšanja korisničkog iskustva. U tom slučaju korisnici će imati mogućnost da odbiju naš zahtjev za korištenjem kolačića na njihovom web pretraživaču, što neće dovesti do odbijanja pristupa web stranici. Korisnici će u većoj mjeri moći upravljati postavkama kolačića putem svog web pretraživača.
  </p>

  <h3>11. IZMJENE POLITIKE PRIVATNOSTI</h3>
  <p>
    Zadržavamo pravo izmjene ove Politike u bilo kojem trenutku. Sve izmjene biće objavljene na našoj web stranici.
  </p>

  <h3>12. KONTAKT</h3>
  <p>
    Za sve informacije u vezi sa zaštitom ličnih podataka, možete nas kontaktirati putem emaila: <a href="mailto:magnakonsalting@gmail.com">magnakonsalting@gmail.com</a>
  </p>

  <p><em>Datum posljednje izmjene: 25.05.2025<br />
  Objavljeno na web stranici: <a href="https://magna.ba" target="_blank" rel="noopener noreferrer">magna.ba</a></em></p>
</div>

      </div>
    </div>
  );
};

export default PrivacyPolicyModal;
